import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import useAPI from "../hooks/useAPI";

import { useDispatch } from "react-redux";
import allFormActions from "../state/forms/actions/index";
import { set } from "lodash";

export default function useAdminForms(props) {
  const dispatch = useDispatch();
  const localUser = JSON.parse(localStorage.getItem("kdmUser"));
  const superUser = localUser.sub === process.env.REACT_APP_ADMIN_UID;

  const [apiError] = useState(false); //TODO:Placer dans useAPI

  const [exportList] = useState([]);

  const { data, query: fetchData } = useAPI({
    type: "get",
    url: `forms`,
  });

  const { data2, query: exportData } = useAPI({
    defer: true,
    type: "get",
    url: `forms/export`,
  });

  const forms = useSelector((state) => {
    return state.forms.forms;
  });

  const handleDelete = async (id) => {
    console.log("must no be implemented");
  };

  const handleRefreshData = async () => {
    await fetchData();
  };

  const handleExportData = async () => {
    await exportData();
    const csvHeader = Object.keys(data2[0]).join(",") + "\n";
    const csvRows = data2
      .map((row) => {
        return Object.values(row).join(",");
      })
      .join("\n");
    const data3 = csvHeader + csvRows;
    const blob = new Blob([data3], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const filename = `forms_export_${new Date().toISOString()}.csv`;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };

  useEffect(() => {
    if (data && data.data) {
      dispatch(allFormActions.formActions.fetchAllForms(data.data));
    }
    if (data && data.data2) {
      set(exportList, data.data2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, data2]);

  return {
    forms,
    superUser,
    onDelete: handleDelete,
    onRefreshData: handleRefreshData,
    onExportData: handleExportData,
    apiError,
  };
}
